<form [formGroup]="paymentForm" (ngSubmit)="submitForm()" class="tab-form" autocomplete="off" novalidate>
  <div class="form-80">
    <h1 class="blue margin">{{title}}</h1>
    <p style="font-weight: 500; font-size: large; line-height: 1.5; margin-bottom: 24px;">
      To activate your account, please ensure to complete the process by depositing a minimum of <strong>KES 5,000</strong> 
      via M-Pesa or bank transfer. If the amount is already deposited, enter the transaction details 
      as below and confirm your payment
    </p>

    <div class="flex blue-box" >
      <p class="blue lead" >
        {{'Payment'}}
      </p>
      <div class="line-2"></div>

      <div class="row" [ngClass]="{'half': paymentForm.controls['PaymentMode'].value === PaymentModeOptions[0] || paymentForm.controls['PaymentMode'].value === PaymentModeOptions[2] }">
        <app-input
          [formGroup]="paymentForm"
          controlName="PaymentMode"
          label={{paymentModeLabel}}
          inputType="select"
          [ArrayItems]="PaymentModeOptions"
          [validationMessages]="validationMessages" [formErrors]="formErrors" >
        </app-input>

        <app-input [formGroup]="paymentForm" controlName="receipt"  *ngIf="paymentForm.controls['PaymentMode'].value === PaymentModeOptions[1]"
          label="M-PESA Receipt" hint={{receiptLabel}} subtext={{receiptHint}} required="false"
          [validationMessages]="validationMessages" [formErrors]="formErrors" >
        </app-input>

        <app-input [formGroup]="paymentForm" controlName="amount" *ngIf="paymentForm.controls['PaymentMode'].value === PaymentModeOptions[3]"
            label={{investmentAmountLabel}} hint={{investmentAmountHint}}
            [subtext]="investmentAmountSubtext"
            [validationMessages]="validationMessages" [formErrors]="formErrors" >
          </app-input>
      </div>
      <!-- MPESA EXPRESSS SELECTED ? -->
      <div class="mini" *ngIf="paymentForm.controls['PaymentMode'].value === PaymentModeOptions[0]">
        <div class="row">
          <app-input [formGroup]="paymentForm" controlName="phone"
            label={{phoneLabel}} inputType="phone"
            [validationMessages]="validationMessages" [formErrors]="formErrors" >
          </app-input>
          <app-input [formGroup]="paymentForm" controlName="amount"
            label={{investmentAmountLabel}} hint={{investmentAmountHint}}
            [subtext]="investmentAmountSubtext"
            [validationMessages]="validationMessages" [formErrors]="formErrors" >
          </app-input>
        </div>
        <div class="badge-wrapper">
          <div class="badge">
            <p class="lead blue" style="font-size: larger; margin-left: 2.8%; font-weight: 600;">
              {{instructionsTitle}}
            </p>
            <ol>
              <li>{{inst1}}</li>
              <li>Click on the <strong>"Submit"</strong> Button below.</li>
              <li>{{inst2}}</li>
              <li>{{inst2X}}</li>
              <li>{{inst3}}</li>
            </ol>
            <div style="height: 20px;"></div>
          </div>
        </div>
      </div>
      <!-- MPESA PAYBILL SELECTED ? -->
      <div class="mini" *ngIf="paymentForm.controls['PaymentMode'].value === PaymentModeOptions[1]">
        <div class="badge-wrapper">
          <div class="badge">
            <p class="lead blue" style="font-size: larger; margin-left: 2.8%; font-weight: 600;">
              {{instructionsTitle2}}
            </p>
            <ol>
              <li>{{inst4}}</li>
              <li>{{inst5}}<b>{{iceaPaybill}}</b></li>
              <li>{{inst6}}<b>{{ paymentID }}</b></li>
              <li>Set a minimum of <strong>Ksh 5000</strong> (or greater) as the amount</li>
              <li>{{inst8}}</li>
              <li>Please do <strong>NOT</strong> close this page <strong>UNTIL</strong> the Payment is confirmed</li>
              <li>If the payment isn't completed automatically, use the <strong>"Confirm Payment"</strong> Button to Conclude</li>
            </ol>
            <div style="height: 20px;"></div>
          </div>
        </div>
      </div>
      <!-- BANK SELECTED ? -->
      <div class="mini" *ngIf="paymentForm.controls['PaymentMode'].value === PaymentModeOptions[2]">
        <div class="row">
          <app-input [formGroup]="paymentForm" controlName="amount"
            label={{investmentAmountLabel}} hint={{investmentAmountHint}} [subtext]="investmentAmountSubtext"
            [validationMessages]="validationMessages" [formErrors]="formErrors" >
          </app-input>
          <app-input [formGroup]="paymentForm" controlName="bank"
            [selectFunction]="populateBankBranchesList.bind(this)"
            inputType="select"
            [ArrayItems]="BanksOptions"
            [loadingOptions]="loadingBanks"
            label={{bankLabel}} hint={{bankHint}}
            [validationMessages]="validationMessages" [formErrors]="formErrors">
          </app-input>
        </div>

        <div class="row">
          <app-input [formGroup]="paymentForm" controlName="bankBranch"
            label={{bankBranchLabel}} hint={{bankBranchHint}}
            inputType="select"
            [ArrayItems]="BranchPlaceHolders"
            [loadingOptions]="loadingBankBranches"
            [validationMessages]="validationMessages" [formErrors]="formErrors">
          </app-input>
          <app-input [formGroup]="paymentForm" controlName="accName"
            label={{accNameLabel}} hint={{accNameHint}}
            [validationMessages]="validationMessages" [formErrors]="formErrors" >
          </app-input>
        </div>

        <div class="row">
          <app-input [formGroup]="paymentForm" controlName="acc"
            label={{accLabel}} hint={{accHint}}
            [validationMessages]="validationMessages" [formErrors]="formErrors">
          </app-input>
          <app-input [formGroup]="paymentForm" controlName="slipDoc"
            [fileFunction]="updateSlipObject.bind(this)"
            label={{uploadSlipLabel}} inputType="file"
            [validationMessages]="validationMessages" [formErrors]="formErrors" >
          </app-input>
        </div>

        <div class="bankBox-wrap">
          <div class="bankBox">
            <p class="lead blue" style="margin-bottom: -20px; margin-left: 0px; font-weight: 600;">
              {{instructionsTitleBank}}
            </p>
            <div class="line"></div>
            <div class="row">
              <div>{{iceaFundLabel}}</div> <div class="right-divs">{{iceaFundNameVal}}</div>    
            </div>
            <div class="row">
              <div>{{iceaAcc}}</div> <div class="right-divs">{{iceaAccountVal}}</div>
            </div>
            <div class="row">
              <div>{{iceaBank}}</div> <div class="right-divs">{{iceaBankVal}}</div>
            </div>
            <div class="row">
              <div>{{iceaBranch}}</div> <div class="right-divs">{{iceaBranchVal}}</div>
            </div>
            <div class="row">
              <div>{{iceaBranchCode}}</div> <div class="right-divs">{{iceaBranchCodeVal}}</div>
            </div>
            <div class="row">
              <div>{{iceaClearing}}</div> <div class="right-divs">{{iceaClearingVal}}</div>
            </div>
          </div>
        </div>
      </div>

      <!-- PAYMENT DIRECT CARD -->
      <div *ngIf="paymentForm.controls['PaymentMode'].value == PaymentModeOptions[3]">
        <app-cards #cardsComponent
          returnURL="trust-fund/set-up"
          [formGroup]="paymentForm"
          [payer]="settlors[0]"
          [amount]="amountRaw"
          (paymentSuccess)="onCardPaymentSuccess()"
        ></app-cards>
        <!-- CARD DETAILS -->
        <div class="badge-wrapper">
          <div class="badge">
            <p class="lead blue" style="font-size: larger; margin-left: 2.8%; font-weight: 600;">
              {{'Card Payment Instructions'}}
            </p>
            <ol>
              <li>Ensure you have filled in the card details form above correctly (The <strong>Submit</strong> Button should turn <strong>blue</strong>)</li>
              <li>Please do <strong>NOT</strong> close this page <strong>UNTIL</strong> the Payment is confirmed</li>
            </ol>
            <div style="height: 20px;"></div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- BOTTOM OF FORM -->
  <app-form-bottom style="width: 100%;"
    [text]="loading ? buttonText : paymentForm.controls['PaymentMode'].value === PaymentModeOptions[1] ? 'Confirm Payment' : 'Submit'"
    [formValid]="paymentForm.controls['PaymentMode'].value === PaymentModeOptions[1] ? true : paymentForm.valid"
    [showContinue]="paymentForm.valid ? 'true' : 'false'"
    [saveFunction]="updateProgress.bind(this)"
    [buttonClickHandler]="submitForm.bind(this)">
  </app-form-bottom>
</form>
